import { createAction, props } from '@ngrx/store'
import type { User } from './auth.model'

// login action
export const login = createAction(
  '[Authentication] Login',
  props<{ email: string; password: string }>()
)
export const loginSuccess = createAction(
  '[Authentication] Login Success',
  props<{ user: User }>()
)
export const loginFailure = createAction(
  '[Authentication] Login Failure',
  props<{ error: string }>()
)

// // Send OTP to phone number
// export const sendOtp = createAction(
//   '[Authentication] Send OTP',
//   props<{ userLogin: UserLogin }>()
// );

export const sendOtpSuccess = createAction(
  '[Authentication] Send OTP Success',
  props<{ isSend: boolean }>()
);

export const sendOtpFailure = createAction(
  '[Authentication] Send OTP Failure',
  props<{ error: string }>()
);


// Validate User
export const validateUser = createAction(
  '[Authentication] Validate User',
  props<{ phoneNumber: string }>()
);

// export const validateUserSuccess = createAction(
//   '[Authentication] Validate User Success',
//   props<{ user: UserLoginResponse }>()
// );

export const validateUserFailure = createAction(
  '[Authentication] Validate User Failure',
  props<{ error: string }>()
);

// Forgot Password
export const forgotPassword = createAction(
  '[Authentication] Forgot Password',
  props<{ phoneNumber: string }>()
);

// logout action
export const logout = createAction('[Authentication] Logout')

export const logoutSuccess = createAction('[Auth] Logout Success')
